import { Document, PDFViewer } from '@react-pdf/renderer';
import { Modal } from 'antd';
import React from 'react';
import OutstandingBalance from '../pdf/report/OutstandingBalance';
import ReleaseOrderRegister from '../pdf/report/ReleaseOrderRegister';
import LedgerReport from '../pdf/report/LedgerReport';
import PartywiseRORegister from '../pdf/report/PartywiseRORegister';
import PeriodwiseTotalTDSList from '../pdf/report/PeriodwiseTotalTDSList';
import PeriodwiseTotalGSTList from '../pdf/report/PeriodwiseTotalGSTList';
import PartyBillGSTList from '../pdf/report/PartyBillGSTList';
import PeriodwiseBillwiseReceiptPending from '../pdf/report/PeriodwiseBillwiseReceiptPending';
import CompanyBillGST from '../pdf/report/CompanyBillGST';
import PartywiseTotalTDSList from '../pdf/report/PartywiseTotalTDSList';
import AccountwiseRO from '../pdf/report/AccountwiseRO';

const ReportPdfModal = (props) => {
    const { visible, close, data, title, pdfType, dates } = props;

    const getPdfComponent = (pdfType, data) => {
        switch (pdfType) {
            case "releaseOrderRegister":
            case "classifiedReleaseOrderRegister":
                return <ReleaseOrderRegister data={data} pdfType={pdfType} key={pdfType} />
            case "outstandingBalance":
                return <OutstandingBalance data={data} pdfType={pdfType} key={pdfType} />
            case "accountLedger":
                return <LedgerReport data={data} pdfType={pdfType} key={pdfType} />
            case "partywiseRO":
                return <PartywiseRORegister data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "TDSList":
                return <PeriodwiseTotalTDSList data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "GSTList":
                return <PeriodwiseTotalGSTList data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "partyBillsGST":
                return <PartyBillGSTList data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "receiptPending":
                return <PeriodwiseBillwiseReceiptPending data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "publicationBillGST":
                return <CompanyBillGST data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "partywiseTDS":
                return <PartywiseTotalTDSList data={data} pdfType={pdfType} key={pdfType} dates={dates} />
            case "accountwiseRO":
                return <AccountwiseRO data={data} pdfType={pdfType} key={pdfType} />
        }
    }

    return (
        <Modal
            title="Print Preview"
            open={visible}
            width={1250}
            onCancel={close}
            footer={null}
            maskClosable={false}
        >
            <PDFViewer style={{ width: 1200, height: 750 }}>
                <Document title={title}>
                    {getPdfComponent(pdfType, data)}
                </Document >
            </PDFViewer>
        </Modal>
    );
}

export default ReportPdfModal;